import { Router, ActivatedRoute } from '@angular/router';
import { AlertService } from './../service/alert.service';
import { RecuperarSenhaService } from './../service/recuperar-senha.service';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators, ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';

@Component({
  selector: 'app-recuperar-senha',
  templateUrl: './recuperar-senha.component.html',
  styleUrls: ['./recuperar-senha.component.css']
})
export class RecuperarSenhaComponent implements OnInit
{
  form!: FormGroup
  token: any
  minimoSeisCaracteres: ValidatorFn = (control: AbstractControl): ValidationErrors | null =>
  {
    return (control.value).length < 6 ? { minimocaracteres: true } : null;
  };
  temLetras: ValidatorFn = (control: AbstractControl): ValidationErrors | null =>
  {
    var temLetras: boolean = /[A-Za-z]/.test(control.value);

    return !temLetras ? { naotemletras: true } : null;
  };
  temNumeros: ValidatorFn = (control: AbstractControl): ValidationErrors | null =>
  {
    var temNumeros: boolean = /[0-9]/.test(control.value);

    return !temNumeros ? { naotemnumeros: true } : null;
  };
  temSimbolos: ValidatorFn = (control: AbstractControl): ValidationErrors | null =>
  {
    var temSimbolos: boolean = /[!@#$%^&*(),.?":{}|<>]/.test(control.value);

    return !temSimbolos ? { naotemsimbolos: true } : null;
  };
  constructor(
    private builder: FormBuilder,
    private senhaService: RecuperarSenhaService,
    private alertService: AlertService,
    private router: Router,
    private activatedRoute: ActivatedRoute
  )
  {
    this.form = this.builder.group({
      token: new FormControl(this.activatedRoute.snapshot.paramMap.get('token')!, Validators.required),
      vc_senha: new FormControl('', [
        this.minimoSeisCaracteres,
        this.temLetras,
        this.temNumeros,
        this.temSimbolos,
      ]),
      vc_senha_confirmation: new FormControl(''),
      recaptcha: new FormControl(false, Validators.requiredTrue),
    });
  }

  ngOnInit(): void
  {
    this.acompanharMudancasFormulario();
  }

  validarRecaptcha(captchaValido?: string): void
  {
    var captchaDeuCerto: boolean = typeof captchaValido === 'string';

    this.form.get('recaptcha')?.setValue(captchaDeuCerto);
  }

  submit(): void
  {
    if (this.form.invalid) {
      this.alertService.error('Formulário inválido. Por favor, verifique-o e tente novamente.');
    } else {
      this.enviarNovaSenha();
    }
  }

  enviarNovaSenha(): void
  {
    this.senhaService.enviarNovaSenha(this.form.value).subscribe((resp: any) =>
    {
      this.alertService.success(resp.mensagem);
      this.router.navigate(['/']);
    }, error =>
    {
      this.alertService.error(error.error.mensagem);
    })
  }

  senhasTemErro(erro: string): boolean
  {
    var controlSenha: AbstractControl = this.form.controls['vc_senha'];

    return controlSenha.hasError(erro);
  }

  senhasCoincidem(): boolean
  {
    var controlSenha: AbstractControl = this.form.controls['vc_senha'];
    var controlConfirmacaoSenha: AbstractControl = this.form.controls['vc_senha_confirmation'];
    var formularioTemErro: boolean = this.form.hasError('senhasdiferentes');
    var formularioJaAlterado: boolean = controlSenha.dirty && controlConfirmacaoSenha.dirty;

    if (formularioJaAlterado) {
      return !formularioTemErro;
    }

    return true;
  }

  acompanharMudancasFormulario(): void
  {
    this.form.valueChanges.subscribe(() =>
    {
      this.verificacaoSenhas();
    });
  };

  verificacaoSenhas(): void
  {
    var senha: AbstractControl = this.form.controls['vc_senha'];
    var confirmacaoSenha: AbstractControl = this.form.controls['vc_senha_confirmation'];
    var erroForm: object | null = null;

    if (senha.value !== confirmacaoSenha.value) {
      erroForm = { senhasdiferentes: true };
    }

    this.form.setErrors(erroForm);
  };
}
